export enum ImageType {
  BANNER = 'banner',
  TILE = 'tile',
  '3D_TILE' = '3d-tile',
  BINGO_TILE = 'bingo-tile',
  BACKGROUND = 'background',
  SCREENSHOT_MODAL = 'screenshot-modal',
  SCREENSHOT_CONTENT = 'screenshot-content',
  SEARCH = 'search',
  PROMOTIONS = 'promotions',
}

export interface PictureProps {
  src: string
  alt: string
  className?: string
  loading?: 'lazy' | 'eager'
  type: ImageType
  priority?: boolean
  version?: string
  isWebpFirst?: boolean
  dataTestId?: string
}
